import HybridSocket, { HybridSocketEvents } from '@flipster/socket/HybridSocket';
import { V2SocketEvents } from '@flipster/socket/r230522/socket';

import { bridgeR230522Socket } from './bridge-socket';
import { createPrivateR230522Socket, createPublicR230522Socket } from './web-socket';

export interface HybridR230522Events extends HybridSocketEvents, V2SocketEvents {}

export function createPublicHybridSocket() {
  return new HybridSocket<unknown, HybridR230522Events>(bridgeR230522Socket, createPublicR230522Socket());
}

export function createPrivateHybridSocket() {
  return new HybridSocket<unknown, HybridR230522Events>(bridgeR230522Socket, createPrivateR230522Socket());
}
